// Foundations
import { BlurFoundationsThemes } from '../../commons/blur-foundations.themes';
const FoundationsKubitBnplRegularBlursTheming = {
    layerblur_50: `blur(calc(${BlurFoundationsThemes.blur_150} / 2))`,
};
export { FoundationsKubitBnplRegularBlursTheming };
//# sourceMappingURL=foundations-kubit-bnpl-regular-blurs.theming.js.map